import { useContext, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { currentDateAndTime } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { decodeData } from "../../Constants/constants";
import { useLocation } from "react-router-dom";
function LeaveHistoryImporting() {
    const { apiURL, apiHeaderFile, permissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [loadingImportExcel, setLoadingImportExcel] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [uploadSheets, setUploadSheet] = useState({
        file: null,
        remarks: "",
        leaveBalance: true,
        leaveHistory: true,
    });
    const fileInputRef = useRef(null);

    const handleExcelDownload = () => {
        // Define columns for the first sheet (LeaveHistory)
        const columnsSheet1 = [
            { header: 'Company Code *', key: 'Company Code', width: 14 },
            { header: 'Employee Code *', key: 'Employee Code', width: 14 },
            { header: 'Leave Type *', key: 'Leave Type', width: 22 },
            { header: 'Application Date *', key: 'Application Date', width: 24 },
            { header: 'From Date *', key: 'From Date', width: 24 },
            { header: 'From Date Unit *', key: 'From Date Unit', width: 26 },
            { header: 'To Date *', key: 'To Date', width: 24 },
            { header: 'To Date Unit *', key: 'To Date Unit', width: 26 },
            { header: 'Leave Taken Days *', key: 'Leave Taken Days', width: 26 },
            { header: 'Leave Reason', key: 'Leave Reason', width: 12 },
            { header: 'RM Remark', key: 'RM Remark', width: 10 },
        ];
    
        // Define columns for the second sheet (LeaveBalance)
        const columnsSheet2 = [
            { header: 'Company Code *', key: 'Company Code', width: 20 },
            { header: 'Employee Code *', key: 'Employee Code', width: 15 },
            { header: 'Leave Type *', key: 'Leave Type', width: 22 },
            { header: 'Previous Year Carryforward Balance *', key: 'Previous Year Carryforward Balance', width: 34 },
        ];
    
        // Example data for LeaveHistory
        const exampleDataSheet1 = [
            { 'Company Code': '', 'Employee Code': '', 'Leave Type': 'Use These Codes: PL/CL/SL', 'Application Date': 'Use this format : 12-Jan-2024', 'From Date': 'Use this format : 12-Jan-2024', 'From Date Unit': 'Full Day/First Half/Second Half', 'To Date': 'Use this format : 12-Jan-2024', 'To Date Unit': 'Full Day/First Half/Second Half', 'Leave Reason': '', 'RM Remark': '' },
        ];
    
        // Example data for LeaveBalance
        const exampleDataSheet2 = [
            { 'Company Code': '', 'Employee Code': '', 'Leave Type': 'Use These Codes: PL/CL/SL', 'Previous Year Carryforward Balance': 'If no carryforward then enter 0 (Zero)' },
        ];
    
        // Create a new workbook
        const wb = XLSX.utils.book_new();
    
        // Create the first sheet (LeaveHistory) with headers and data
        const ws1 = XLSX.utils.json_to_sheet(exampleDataSheet1);
        XLSX.utils.sheet_add_aoa(ws1, [columnsSheet1.map(col => col.header)], { origin: 'A1' });
        ws1['!cols'] = columnsSheet1.map(column => ({ wch: column.width }));
    
        // Create the second sheet (LeaveBalance) with headers and data
        const ws2 = XLSX.utils.json_to_sheet(exampleDataSheet2);
        XLSX.utils.sheet_add_aoa(ws2, [columnsSheet2.map(col => col.header)], { origin: 'A1' });
        ws2['!cols'] = columnsSheet2.map(column => ({ wch: column.width }));
    
        // Append both sheets to the workbook
        XLSX.utils.book_append_sheet(wb, ws1, 'LeaveHistory');
        XLSX.utils.book_append_sheet(wb, ws2, 'LeaveBalance');
    
        // Write the workbook to a file
        XLSX.writeFile(wb, 'LeaveHistoryImport.xlsx');
    
        // Show success message after the download
        Swal.fire({
            title: '<strong>Success</strong>',
            html: 'Your file has been downloaded successfully.',
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
        });
    };
    
    function uploadEmployee() {

        setLoadingImportExcel(true);
        // Create FormData instance
        let formData = new FormData();
    
        // Add file and other fields to formData
        formData.append('file', uploadSheets.file);  // assuming uploadSheets.file contains the file
        formData.append('remarks', uploadSheets.remarks);
        formData.append('leaveBalance', uploadSheets.leaveBalance);
        formData.append('leaveHistory', uploadSheets.leaveHistory);
        formData.append('date', currentDateAndTime());
    
        const header = {
            ...apiHeaderFile,
            // 'Content-Type' should not be set manually for FormData
        }
    
        // console.log("ImportLeaveBalanceAndHistory ~ formData", formData);
        
        const options = {
            url: `${apiURL}Masters/ImportLeaveBalanceAndHistory`,
            method: "POST",
            headers: header,
            data: formData, // Use formData here
            
        };
    
        axios(options)
            .then((response) => {
                // console.log("uploadEmployee ~ response", response?.data);
                if (response?.data?.success === true) {
                   
                    setSuccessMsg(response?.data?.msg);
                    console.log("response?.data?.msg",response?.data?.msg);
                    setUploadSheet({
                        file: null,
                        remarks: "",
                        leaveBalance: true,
                        leaveHistory: true,
                    });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                      }

                } else if (response?.data?.success === false) {
                    setErrorMsg(response?.data?.message || "There is a problem to upload excel!!");
                }
                setLoadingImportExcel(false);
            })
            .catch((e) => {
                console.log(e);
                setErrorMsg(e?.response?.data?.message || "There is a problem to upload excel!!");
                setLoadingImportExcel(false);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (uploadSheets.file
        ) {
            uploadEmployee();
        }
        else if (
            !uploadSheets.file
        ) {
            setErrorMsg("Please select excel file to upload data.");
        }
    }
    // console.log("success", successMsg);
    return (
        <div class="main-content" >
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Leave Import`} primary={`Home`} />
                    <div className="card">
                        <div className="card-header align-items-center justify-content-between d-flex">
                            <h4 className="card-title mb-0 flex-grow-1">{"Leave History Import"}</h4>                                   
                        </div>
                        <div className="card-body">
                            <div className="row">
                            <div className="col-md-4">
                                <label htmlFor="keyword">File Upload</label>
                                <div className="input-group">
                                    <input type="file" ref={fileInputRef} onChange={(e) => { setUploadSheet({ ...uploadSheets, file: e.target.files[0] }) }} accept=".xlsx" className="form-control" name="fileUpload" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="File Upload" disabled={(!decodedData?.includes(6)) } />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="keyword">Remarks</label>
                                <div className="input-group">
                                    <input type="text" value={uploadSheets?.remarks} onChange={(e) => { setUploadSheet({ ...uploadSheets, remarks: e.target.value }) }} className="form-control" name="remarks" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Remarks" disabled={(!decodedData?.includes(6)) } />
                                </div>
                            </div>
                            {(decodedData?.includes(6)) && (
                            <div className="col-md-2" style={{ width: "14%" }}>
                                <label htmlFor="keyword">Upload</label>
                                <div>
                                    {!loadingImportExcel ?
                                    
                                        <button type="button" onClick={(e) => handleSubmit(e)} className={`btn btn-info btn-label waves-effect waves-light w-100 ${uploadSheets?.file ? "" : "disabled"}`}>
                                            <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Upload
                                        </button> :
                                        <button type="button" className={`btn btn-info btn-label waves-effect waves-light w-100`}>
                                            <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Processing...
                                        </button>
                                    }
                                </div>
                            </div>
                            )}
                            { decodedData?.includes(6) &&(
                            <div style={{ width: "17%" }} className='col-md-3'>
                                <div>
                                    <label>Sample Excel</label>
                                </div>
                                <button
                                    type="button"
                                    onClick={handleExcelDownload}
                
                                    className={` noWrap btn btn-success btn-label waves-effect waves-light`}>
                                    <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                    Download Excel
                                </button>
                            </div>
                            )}
                        </div>
                        {successMsg ?
                            <div className=" position-relative alert alert-success mt-3" role="alert">
                                {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                            </div>
                            : null
                        }
                        {errorMsg ?
                            <div className=" position-relative alert alert-danger mt-3" role="alert">
                                {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                            </div> : null
                        }
                        </div>                                
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LeaveHistoryImporting;